export const EDD_TAG_TEST_ID = 'EDDTag';
export const EDD_TAG_FLIGHT_STATUS_TEST_ID = 'EDDTag-FlightStatus';
export const EDD_TAG_EDD_TEXT_TEST_ID = 'EDDTag-EddText';
export const EDD_TAG_TOOLTIP_FLOAT_TEST_ID = 'EDDTag-Tooltip-Float';
export const EDD_TAG_A11Y_DESC_TEST_ID = 'eddTagA11yDesc';
